import React from "react";
import { ReactComponent as Whatsapp } from "../assets/icons/whatsapp.svg";
import { ReactComponent as Facebook } from "../assets/icons/facebook.svg";
import { ReactComponent as Email } from "../assets/icons/Email.svg";
import { ReactComponent as YouTube } from "../assets/icons/Youtube.svg";
import { ReactComponent as CallIcon } from "../assets/icons/Call.svg";
import { ReactComponent as Location } from "../assets/icons/Location.svg";
import { useNavigate } from "react-router-dom";

interface Props {
  title: string;
  item1: { name: string; path: string };
  item2: { name: string; path: string };
  item3?: { name: string; path: string };
  item4?: { name: string; path: string };
  item5?: { name: string; path: string };
  item6?: { name: string; path: string };
}

const footerDetails: Props[] = [
  {
    title: "Sitemap",
    item1: { name: "Home", path: "/" },
    item2: { name: "About us", path: "/about" },
    item3: { name: "CBR Program", path: "/cbr-program" },
    item4: { name: "Resources", path: "/resources" },
    item5: { name: "Contacts", path: "/contacts" },
    item6: { name: "Support Us", path: "/support-us" },
  },
  {
    title: "Resources",
    item1: { name: "Books", path: "/resources" },
    item2: { name: "Videos", path: "/resources" },
  },
  {
    title: "Help Center",
    item1: { name: "FAQs", path: "" },
    item2: { name: "Contacts & Regions", path: "/contacts" },
  },
];

const currentYear = new Date().getFullYear();

function Footer() {
  const navigate = useNavigate();

  const handleDownload = async (apiEndpoint: string, defaultFilename: string) => {
    try {
      // 1. Fetch metadata from API 
      const apiUrl = `${process.env.REACT_APP_API_URL || ""}${apiEndpoint}?populate=*`;
      const apiResponse = await fetch(apiUrl);
      
      if (!apiResponse.ok) {
        throw new Error("Failed to fetch document metadata");
      }
      
      const data = await apiResponse.json();
      
      let fileUrl = data?.data?.file?.url || data?.data?.attributes?.file?.data?.attributes?.url;
      
      if (!fileUrl) {
        console.log("No file URL available");
        return;
      }

      // Ensure URL is absolute
      const fullFileUrl = fileUrl.startsWith('http') 
        ? fileUrl 
        : `${process.env.REACT_APP_API_URL || ""}${fileUrl}`;

      try {
        // Fetch the file as a blob
        const response = await fetch(fullFileUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch file");
        }

        const blob = await response.blob();

        // Extract filename from URL or use a default
        const urlParts = fullFileUrl.split("/");
        const filename = urlParts[urlParts.length - 1].split("?")[0] || defaultFilename;

        // Create a temporary download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (downloadError) {
        console.error("Error downloading file:", downloadError);
        // Fallback to opening in new window if download fails
        window.open(fullFileUrl, "_blank");
      }
    } catch (error) {
      console.error("Error fetching document data:", error);
      // Fail gracefully and leave user on site
    }
  };

  const handleItemClick = (item?: { name: string; path: string }) => {
    if (!item) return;
    if (item.name === "FAQs") {
      handleDownload("/api/faq", "FAQ.pdf");
      return;
    }
    navigate(item.path);
  };

  return (
    <div className="container mx-auto">
      <div className=" flex flex-col md:flex md:flex-row gap-20 lg:justify-between w-full mb-16 pt-16 ">
        <div className=" flex flex-col  gap-4">
          <h1 className="text-5xl text-mainBlue font-bold">CBR</h1>
          <p className="leading-7 font-light text-gray-600 lg:w-[248px]">
            Empowering believers with the discipline of daily & systematic
            reading of God's Word
          </p>

          <div className="flex gap-4">
            <Facebook />
            <YouTube />
          </div>
        </div>

        <div className="flex flex-row lg:w-1/2  justify-between ">
          {footerDetails.map((footer, index) => (
            <div key={index}>
              <h1 className="font-semibold text-lg mb-10 text-darkerGrey">
                {footer?.title}
              </h1>

              <div className="flex text-activeDarkGrey font-normal flex-col gap-6">
                {footer?.item1 && <p className="cursor-pointer" onClick={() => handleItemClick(footer.item1)}>{footer.item1.name}</p>}
                {footer?.item2 && <p className="cursor-pointer" onClick={() => handleItemClick(footer.item2)}>{footer.item2.name}</p>}
                {footer?.item3 && <p className="cursor-pointer" onClick={() => handleItemClick(footer.item3)}>{footer.item3.name}</p>}
                {footer?.item4 && <p className="cursor-pointer" onClick={() => handleItemClick(footer.item4)}>{footer.item4.name}</p>}
                {footer?.item5 && <p className="cursor-pointer" onClick={() => handleItemClick(footer.item5)}>{footer.item5.name}</p>}
                {footer?.item6 && <p className="cursor-pointer" onClick={() => handleItemClick(footer.item6)}>{footer.item6.name}</p>}
              </div>
            </div>
          ))}
        </div>

        <div className=" flex flex-col  ">
          <h1 className=" font-semibold text-lg mb-10 text-blackBlue">
            Get in Touch
          </h1>
          <div className="flex text-activeDarkGrey font-normal flex-col gap-6">
            <p className="flex gap-2 items-center">
              {<Whatsapp onClick={() => console.log("Whatsapp")} />} |
              <CallIcon />
              +254 700 918161
            </p>
            <p className="flex gap-2 items-center">
              <Email />
              info@wordfeast.org
            </p>

            <p className="flex gap-2 ">
              <Location className="mt-1" />
              P.O. BOX 2131-010100 <br /> Nyeri, Kenya
            </p>
          </div>
        </div>
      </div>

      <div className=" flex flex-col lg:flex lg:flex-row font-normal text-sm justify-between py-9 border-t">
        <p className="lg:w-1/2  text-darkGrey">
          (c) {currentYear} CBR, A Program of Word Feast | All Rights
          Reserved
        </p>

        <div className="flex gap-16 text-activeDarkGrey lg:justify-end lg:w-1/2">
          <p className="cursor-pointer" onClick={() => handleDownload("/api/privacy-policy", "Privacy_Policy.pdf")}>Privacy Policy</p>
          <p>Terms & Conditions</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
